<template>
  <div class="filter-container">
    <div class="filter-button" @click="toggleFilterDropDown()">
      <icon size="18">tune</icon>
      <p>Applied Filters ({{ selectedFilters.length }})</p>
      <icon :class="[{ rotate: isDropped }]">arrow_drop_down</icon>
    </div>
    <SlideYUpTransition>
      <div v-if="isDropped" ref="options" :class="['options', 'shadow-down']">
        <div
          :class="[
            'option',
            {
              active:
                selectedFilters.filter((filter) => filter.colname === option.id)
                  .length > 0,
            },
          ]"
          v-for="option in options"
          :key="option.id"
          @click="stopPropagation"
        >
          <p class="ellipsis">
            {{ option.name }} ({{
              selectedFilters.filter((filter) => filter.colname === option.id)
                .length
            }})
          </p>
          <i class="material-icons drop-down-icon">arrow_right</i>
          <SearchableSideOptions
            :option="option"
            :suboptions="option.options"
            :selectedFilters="selectedFilters"
            @onFilterSelected="emitSelectedFilter"
          />
        </div>
      </div>
    </SlideYUpTransition>
  </div>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";
import SearchableSideOptions from "@/components/entities/views/SearchableSideOptions";

export default {
  components: {
    SlideYUpTransition,
    SearchableSideOptions,
  },
  props: {
    options: Array,
    selectedFilters: Array,
  },
  data() {
    return {
      isDropped: false,
    };
  },
  methods: {
    toggleFilterDropDown() {
      this.isDropped = !this.isDropped;
    },
    closeDropDown() {
      this.isDropped = false;
    },
    stopPropagation($event) {
      $event.stopPropagation();
    },
    emitSelectedFilter(filter) {
      this.$emit("onFilterSelected", filter);
    },
    selectItem(option, suboption) {
      this.$emit("onFilterSelected", {
        colname: option.id,
        comparison: "=",
        value: suboption.name,
      });
    },
    removeListener() {
      this.closeDropDown();
      document.removeEventListener("click", this.removeListener, false);
    },
  },
  watch: {
    isDropped(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener("click", this.removeListener);
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss">
.filter-container {
  position: relative;

  .filter-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: var(--color-default-background);
    transition: 0.2s all ease-in-out;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    padding: 0 10px;
    z-index: 100;
    margin: 0 10px;

    p {
      margin: 0;
      padding: 12px 15px 12px 15px;
      flex: 1;
    }

    i {
      transition: 0.2s all ease-in-out;

      &.caret {
        margin: 0 0 0 5px;
      }
    }

    .rotate {
      transform: rotate(180deg);
    }

    &:hover {
      cursor: pointer;
      border: 1px solid var(--color-accent);
    }

    &:active {
      opacity: 0.7;
    }
  }

  .options {
    position: absolute;
    width: calc(100% - 20px);
    background: var(--color-secondary);
    z-index: 99;
    max-height: 300px;
    top: 50px;
    left: 10px;
    border-radius: 5px;
    border: 1px solid var(--border-color);

    &.dropup {
      top: auto !important;
      bottom: 50px !important;
    }

    &:last-child {
      border-bottom: 0 !important;
    }
    .option {
      border-bottom: 1px solid var(--border-color);
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      cursor: default;

      &.active {
        color: var(--color-primary);
      }

      .suboptions {
        display: none;
        position: absolute;
        width: 200px;
        top: 0;
        right: 0;
        background: var(--color-secondary);
        transform: translateX(100%);
        border-radius: 5px;
        border: 1px solid var(--border-color);
        color: white;

        .list-wrapper {
          overflow: auto;
          max-height: 250px;
        }

        input {
          width: calc(100% - 10px);
          box-sizing: border-box;
          min-width: 0;
        }

        .option {
          cursor: pointer;
        }
      }

      &:hover {
        background-color: var(--border-color);

        .suboptions {
          display: block;
        }
      }

      p {
        margin: 0;
      }
    }
  }
}
</style>
